import http from "../helpers/httpCommon";

class WidgetDataService {
    create(data) {
        return http().post("/widgetDataCreate", data);
    }

    read(data) {
        return http().post("/widgetDataRead", data);
    }

    update(data) {
        return http().post(`/widgetDataUpdate`, data);
    }

    delete(data) {
        return http().post(`/widgetDataDelete`, data);
    }

    list(data) {
        return http().post("/widgetDataList", data)
    }
}

export default new WidgetDataService();
